import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
	selector: 'app-table',
	templateUrl: './table.component.html',
	styleUrls: ['./table.component.scss'],
	imports: [CommonModule, TranslateModule, KeeniconComponent],
})
export class TableComponent implements OnInit {
	@Input() fields: any[] = [];
	@Output() catchItemsToSort = new EventEmitter<any>();
	@Input() values: any[] = [];
	@Output() catchItemsToDelete = new EventEmitter<any>();
	@Input() showCheckboxDelete: boolean;

	_subscriptions: Subscription[] = [];

	ngOnInit(): void {
		//
	}
}
